import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthenticationResponse, AuthenticationService } from "../_services";

@Injectable()
export class AuthGuard implements CanActivate {
    user: AuthenticationResponse;

    constructor(
        private router: Router,
        private authService: AuthenticationService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this.user = this.authService.userValue;
        this.checkPerfil();
        if (!this.authService.isAuthenticated()) {
            this.router.navigate(['login']);
            return false;
        }
        this.authService.isExpired();

        if(route.data.roles && !route.data.roles.includes(this.user.perfil)){
            this.router.navigate(['/home']);
            return false;
        }
        return true;
    }

    checkPerfil(){
        if(this.user == null){
            let u = this.authService.getUserAuthData();
            if(u == null){
                this.user = new AuthenticationResponse();
                this.user.perfil = ''
            } else {
                this.user = new AuthenticationResponse();
                this.user.perfil = u.perfil;
            }

        }
    }
}
